<template>
  <div class="center-item-body">
    <div class="money-header-body">
      <div class="money-header-box">
        <div class="money-header-p">
          <!--每日充值领奖-->
          <span class="money-header-label">平台币余额</span>
          <span class="money-header-money">{{moneyCount}}</span>
        </div>
        <span class="money-header-go" @click="enterRecharge">立即充值</span>
      </div>
      <div class="money-header-hint">
        <span class="money-header-head">平台币说明:</span>
        <span class="money-header-msg">平台币是101游戏平台的虚拟货币,可用于充值101游戏平台上任何一款页游游戏。</span>
      </div>
    </div>  
    <div class="money-body">
      <div class="money-time-body">
        <span class="money-time-h1">查询时间:</span>
        <DatePicker class="money-time-date" type="daterange" placeholder="请选择查询时间" v-model="date"/>      
        <div @click="queryData" class='money-time-query'>
          <Icon type="ios-search" size="17" style="margin: auto 5px auto 0;"/>查询
        </div>
      </div>
      <div class="money-order-title">最近{{commonTotal}}笔101游戏平台币充值明细</div>
      <div class="money-order-head">
        <p>充值类型</p>
        <p>账号</p>
        <p>101平台币</p>
        <p>充值时间</p>
      </div>
      <ul class="money-order-ul">
        <li class="money-order-li" v-for="(item,index) in platformList" :key="index">
          <span>{{handleType(item.coin_type)}}</span>
          <span>{{item.coin_role_name}}</span>
          <span>{{item.coin_count}}</span>
          <span>{{new Date(item.coin_time).Format("yyyy-MM-dd hh:mm:ss")}}</span>
        </li>
      </ul>
      <CommonPage v-if="isPageShow" class="center-game-page" style="margin: 20px auto;" :current.sync='commonPage' :page-size="commonRow"
        :total="commonTotal" show-total  show-elevator  @on-change="selectPage"
        prev-text="上一页" next-text="下一页"/>
    </div>
  </div>
</template>
 
<script>
  import CommonPage from '../../components/CommonPage';
export default {
  data() {
    return {
      loginState:false,
      moneyCount:0,
      platformList:[],
      commonPage:1,
      commonRow:12,
      commonStart:0,
      commonEnd:0,
      commonTotal:0,
      platformLength:0,
      isPageShow:false,
      date:[
        '',''
      ],
    };
  },
  components:{ CommonPage },
  mounted(){
    if (window.sessionStorage.getItem("token") !== null) {
      this.loginState = true;  
    }  
    this.moneyCount = window.sessionStorage.getItem("userMoney");
    this.queryMineMoney();
  },
  methods:{
    enterRecharge(){
      window.open(this.$router.resolve({name:"recharge",query:{to:2}}).href,"_blank");
    },
    queryMineMoney(){
      if(isNaN(this.commonStart)){
        this.commonStart = 0;
      }
      if(isNaN(this.commonEnd)){
        this.commonEnd = 0;
      }
      this.$http.post('/query_web_mine_money?page='+this.commonPage
      +"&row="+this.commonRow+"&start="+this.commonStart+"&end="+this.commonEnd,{  
      }).then(res =>{
        if(res.data.code == 2000){
          this.platformList =res.data.data;
          this.commonTotal = res.data.total;
          this.platformLength = this.platformList.length;
          if(this.commonTotal > this.commonRow){
            this.isPageShow = true;
          }else{
            this.isPageShow = false;
          }
        }else{
          this.platformList = [];
          this.isPageShow = false;
        }
      })
    },
    queryData(){
      this.commonStart = new Date(this.date[0]).getTime();
      this.commonEnd =new Date(this.date[1]).getTime();
      this.queryMineMoney();
    },
    selectPage(value){
      this.commonPage = value;
      this.queryMineMoney();
    },
    handleType(type){
      if(type == 1 && type == 3 && type == 4){
        return "充值";
      }else{
        return "消耗";
      }
    }
  },
  watch:{
    loginState(value){
      if(value){
        this.queryMineMoney();
      }
    }
  } 
};
</script>
<style src="@/assets/css/mine_center.css" scoped></style>
<style>
  .ivu-row .ivu-col-span-9{
    max-width: 43%;
    flex: 0 0 43%;
  }
</style>